import { AccountTypeService } from '../services/account-type.service'
import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { Observable, map } from 'rxjs'

@Injectable()
export class SimplifiedBlocked implements CanActivate {
  constructor(
    private router: Router,
    private accountTypeService: AccountTypeService
  ) {}

  canActivate(): Observable<boolean> {
    return this.accountTypeService.getSimplificado().pipe(
      map((simplificado) => {
        if (!simplificado) {
          return true
        }
        // Painel Geral é a rota inicial da conta simplificada: a raiz redireciona para /dashboard,
        // que é a Minha Central do Financeiro e fica bloqueada nesse modo.
        this.router.navigate(['/dashboard-inicial'])
        return false
      })
    )
  }
}
